import tenantConfig from 'data/customizer/tenant-config';
import dayjs from 'dayjs';
import { GrAndroid } from 'react-icons/gr';
import { HiOutlineGlobeAlt } from 'react-icons/hi';
import { SiApple } from 'react-icons/si';
import { ORDERS_LISTING_PATH, PRODUCTS_PATH, REVIEWS, SELLERS_LISTING_PATH, UNMAPPED_PRODUCTS_PATH } from './cp-paths';
import {
  ACTION_INDEX,
  ACTION_SHOW,
  PERMISSION_KEY_ORDER,
  PERMISSION_KEY_PRODUCT,
  PERMISSION_KEY_REVIEW,
  PERMISSION_KEY_STORE,
  PERMISSION_KEY_USER,
} from './permission-constants';
import { strings } from './strings';

export const POST = 'post';
export const GET = 'get';
export const PUT = 'put';
export const DELETE = 'delete';

const baseUrl = process.env.REACT_APP_API_URL;

export const baseUrlApi = `${baseUrl}/api`;
export const omsBaseUrlApi = `${baseUrl}/api/seller_center`;
export const cpBaseUrl = `${baseUrl}/api/cp`;

export const MAP_BOX_DEV_API =
  'pk.eyJ1IjoiaHVuaWEtZmF0aW1hOTkiLCJhIjoiY2t5Y3Iza2ZxMHBxeTJwcDVtNXc1amo2dSJ9.7-Q14e_PgJNz4Z_pHJc_YA';

export const DATE_FORMATS = {
  dayMonthDateYear: 'ddd, MMMM DD, YYYY',
  monthDateYear: 'MMM DD, YYYY',
  timePayloadFormat: 'YYYY-MM-DDTHH:mm:ss',
  dayMonthYearFilters: 'Do MMM YYYY',
  dayMonthYear: 'Do MMMM, YYYY',
  weekMonthDayYear: 'dddd, MMMM DD, YYYY',
  hourDayMonthYearTime: 'h:00 A, DD MMM, YYYY',
  hourMinuteDayMonthYearTime: 'hh:mm A, DD MMM, YYYY',
  dayMonthYearTime: 'DD MMM, YYYY, hh:mm A',
  monthDate: 'MMM DD',
  yearMonthDate: 'YYYY-MM-DD',
  dateMonthYear: 'DD-MM-YYYY',
  time: 'hh:mm A',
  dayMonthYearTimeWithSeparator: 'MMM DD, YYYY | hh:mm A',
  monthDayYearTime: 'MMM DD, YYYY, hh:mm A',
  year: 'YYYY',
};

export const INITIAL_LANGUAGE_STATE = {
  dir: 'ltr',
  lang: 'en',
};

export const LANGUAGE_OPTIONS = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'sa',
    label: 'العربية',
  },
];

export const ORDER_STATUSES = (created_at) => [
  {
    title: 'Pending',
    slug: 'pending',
    description: created_at,
  },
  {
    title: 'Confirmed',
    slug: 'confirmed',
  },
  {
    title: 'Shipment Created',
    slug: 'shipment_created',
  },
  {
    title: 'Ready for Pickup',
    slug: 'ready_for_pickup',
  },
  {
    title: 'Dispatched',
    slug: 'dispatched',
  },
  {
    title: 'Delivered',
    slug: 'delivered',
  },
];

export const DELIVERY_CHARTGES = [
  {
    id: 0,
    value: 0,
    name: 'Free',
  },
  {
    id: 1,
    value: 1,
    name: 'Charge Buyer',
  },
];

export const SIDE_MENU_WIDTH = {
  open: 230,
  close: 72,
};

export const FILTER_TYPE = {
  DROP_DOWN: 'dropdown',
  DATE: 'date',
  RANGE: 'range',
  INFINITE_DROP_DOWN: 'infinite-dropdown',
  BOOLEAN_RANGE: 'boolean-range',
  TREE_SELECT: 'tree-select',
  HIDDEN: 'hidden',
  TOGGLE: 'toggle',
  CASCADING_DROPDOWN: 'cascading-dropdown',
};

export const DATE_RANGE_PRESETS = [
  {
    label: 'Yesterday',
    value: [dayjs().subtract(1, 'day').startOf('day'), dayjs().subtract(1, 'day').endOf('day')],
  },
  {
    label: 'Last 7 days',
    value: [dayjs().subtract(6, 'days').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last 30 days',
    value: [dayjs().subtract(29, 'days').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last 60 days',
    value: [dayjs().subtract(59, 'days').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last 90 days',
    value: [dayjs().subtract(89, 'days').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'This Month',
    value: [dayjs().startOf('month'), dayjs().endOf('day')],
  },
  {
    label: 'Last 6 Months',
    value: [dayjs().subtract(6, 'month').startOf('day'), dayjs().endOf('day')],
  },
  {
    label: 'Last Year',
    value: [dayjs().subtract(12, 'month').startOf('day'), dayjs().endOf('day')],
  },
];

export const PERMISSION_MODELS = {
  ORDERS: 'Oms::Orders',
  PRODUCTS: 'Oms::Products',
  PRDOUCT_REVIEW: 'Oms::Prdouct-review',
  MANAGE_USERS: 'Oms::Manage-users',
  ORDER_OVERVIEW: 'Oms::Order-overview',
  ACCOUNT_STATEMENT: 'Oms::Account-statement',
  SHIPMENTS: 'Oms::Consignments',
  CP_REVIEW: 'Cp::Reviews',
  SELLERS: 'Cp::Users',
  CP_ORDER_OVERVIEW: 'Cp::Order-overview',
  CP_ACCOUNT_STATEMENT: 'Cp::Account-statement',
};

export const ORDER_DETAIL_ACTIONS = {
  ACCEPT: 'accept',
  CANCEL: 'cancel',
  CREATE_SHIPMENT: 'create_shipment',
  CONFIRM_PICKUP: 'confirm_pickup',
  DISPATCH: 'mark_dispatched',
  MARK_DELIVERED: 'mark_delivered',
  MARK_RETURNED: 'mark_returned',
  TRACK_ORDER: 'track_order',
  PRINT_SHIPPING_LABEL: 'print_shipping_label',
};

export const BINARY_ACTIONS = [
  {
    id: 1,
    name: 'Yes',
    value: true,
    slug: 'yes',
  },
  {
    id: 2,
    name: 'No',
    value: false,
    slug: 'no',
  },
];

export const BINARY_VALUES = [strings?.yes, strings?.no];

export const PRODUCT_RATING_OPTIONS = [
  { id: 1, label: '1 Star', name: '1 Star', value: '1' },
  { id: 2, label: '2 Stars', name: '2 Stars', value: '2' },
  { id: 3, label: '3 Stars', name: '3 Stars', value: '3' },
  { id: 4, label: '4 Stars', name: '4 Stars', value: '4' },
  { id: 5, label: '5 Stars', name: '5 Stars', value: '5' },
];

export const SELLER_STATUS_OPTIONS = [
  {
    title: 'Pending',
    slug: 'pending',
    id: 'pending',
  },
  {
    title: 'Rejected',
    slug: 'rejected',
    id: 'rejected',
  },
  {
    title: 'Active',
    slug: 'active',
    id: 'active',
  },
  {
    title: 'Inactive',
    slug: 'inactive',
    id: 'inactive',
  },
];

export const USER_STATUS_OPTIONS = [
  { id: 'active', name: 'Active', value: 'active' },
  { id: 'removed', name: 'Removed', value: 'removed' },
];

export const pageSizeOptions = [30, 50, 100];

export const STATUS_OPTIONS = [
  { id: 'Pending', label: 'Pending', name: 'Pending', value: 'Pending' },
  { id: 'Active', label: 'Active', name: 'Active', value: 'Active' },
];

export const BOOLEAN_SELECT_OPTIONS = [
  {
    label: 'Yes',
    value: 'true',
  },
  {
    label: 'No',
    value: 'false',
  },
];

export const DISCOUNT_STATUSES = [
  { id: 'true', name: 'Yes', value: 'true' },
  { id: 'false', name: 'No', value: 'false' },
];

export const THREE_PL_STATUSES = [
  { id: 'false', name: 'Yes', value: 'false' },
  { id: 'true', name: 'No', value: 'true' },
];

export const STOCK_STATUSES = [
  { id: 'true', name: 'In Stock', value: 'true' },
  { id: 'false', name: 'Out of Stock', value: 'false' },
];

export const REVIEW_COMMENT_STATUSES = [
  { id: 'null', title: 'No', value: 'null' },
  { id: 'not_null', title: 'Yes', value: 'not_null' },
];

export const TENANT_ELEMENTS = {
  'OLX-PK': {
    prefix: '+92',
    phone_placeholder: '3000000000',
    tld: 'pk',
    national_id_placeholder: '3820100000000',
    ntn_placeholder: '1234567',
    iban_placeholder: 'PK36SCBL0000001123456702',
  },
  'DUBIZZLE-UAE': {
    prefix: '+971',
    phone_placeholder: '21234567',
    tld: 'ae',
    national_id_placeholder: '784123412345671',
    ntn_placeholder: '123456789012345',
    iban_placeholder: 'AE310215264483426528285',
  },
};

export const FILE_MIME_TYPES = {
  '.png': 'image/png',
  '.jpeg': 'image/jpeg',
  '.jpg': 'image/jpeg',
  '.pdf': 'application/pdf',
  '.doc': 'application/msword',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
};

export const NOTIFICATION_PATHS_PERMISSIONS = {
  '/seller-center/orders/order-details': { permission: PERMISSION_KEY_ORDER, action: ACTION_SHOW },
  '/seller-center/products/manage-products': {
    permission: PERMISSION_KEY_PRODUCT,
    action: ACTION_INDEX,
  },
  '/seller-center/account-settings/manage-users': {
    permission: PERMISSION_KEY_USER,
    action: ACTION_INDEX,
  },
  '/seller-center/account-settings/profile-settings': {
    permission: PERMISSION_KEY_STORE,
    action: ACTION_SHOW,
  },
  '/seller-center/products/reviews': { permission: PERMISSION_KEY_REVIEW, action: ACTION_INDEX },
};

export const TUBE_SCREAMER_URL =
  process.env.REACT_APP_TUBESCREAMER_URL ?? `${process.env.REACT_APP_CONSUMER_URL}/admin/ts/login`;

export const MAX_IMAGE_SIZE = 5242880; // 5MB
export const MAX_IMAGE_COUNT = 8;

export const SELLER_SOURCES = [
  { label: 'Daraz', value: 'Daraz', id: 'Daraz' },
  { label: 'PakWheels', value: 'PakWheels', id: 'PakWheels' },
  { label: 'Shopify', value: 'Shopify', id: 'Shopify' },
];

export const STORE_TYPES = [strings?.official, strings?.test];

export const STORE_TYPES_FOR_SELECT = [
  { name: strings?.yes, id: 'test' },
  { name: strings?.no, id: 'official' },
];

export const CALL_TYPES = [
  { name: strings?.outgoing, id: 'out' },
  { name: strings?.incoming, id: 'in' },
];

export const PREPOSITIONS = [
  'a',
  'an',
  'the',
  'and',
  'but',
  'or',
  'nor',
  'for',
  'so',
  'yet',
  'in',
  'on',
  'at',
  'by',
  'for',
  'to',
  'with',
  'from',
  'about',
  'as',
  'of',
  'up',
  'down',
  'over',
  'under',
  'through',
  'between',
  'during',
  'before',
  'after',
  'since',
  'among',
  'around',
  'along',
  'beneath',
  'within',
  'without',
  'be',
  'have',
  'do',
];

export const CP_DASHBOARD_LINKING_MAP = {
  orders: {
    all: ORDERS_LISTING_PATH,
    pending: tenantConfig?.cp_order?.paths?.pending,
    accepted: `${ORDERS_LISTING_PATH}?f[status.slug]=accepted`,
    'in-transit': `${ORDERS_LISTING_PATH}?f[status.slug]=in-transit`,
    delivered: `${ORDERS_LISTING_PATH}?f[status.slug]=delivered`,
    returned: `${ORDERS_LISTING_PATH}?f[status.slug]=returned`,
    cancelled: `${ORDERS_LISTING_PATH}?f[status.slug]=cancelled`,
    rejected: `${ORDERS_LISTING_PATH}?f[status.slug]=rejected`,
  },
  products: {
    unmapped_products: UNMAPPED_PRODUCTS_PATH,
    all: PRODUCTS_PATH,
    pending: `${PRODUCTS_PATH}?f[status.slug]=pending`,
    rejected: `${PRODUCTS_PATH}?f[status.slug]=rejected`,
    removed: `${PRODUCTS_PATH}?f[status.slug]=removed`,
    active: `${PRODUCTS_PATH}?f[status.slug]=active`,
    out_of_stock: `${PRODUCTS_PATH}?f[total_inventory][lte]=0`,
    inactive: `${PRODUCTS_PATH}?f[disposition.slug][]=inactive`,
    published: `${PRODUCTS_PATH}?f[published]=true&f[status.slug]=active`,
  },
  reviews: {
    all: REVIEWS,
    pending: `${REVIEWS}?f[status.slug][]=pending`,
    moderated: `${REVIEWS}?f[status.slug][]=approved&f[status.slug][]=rejected`,
  },
  sellers: {
    total: `${SELLERS_LISTING_PATH}`,
    active: `${SELLERS_LISTING_PATH}?f[status.slug][]=active`,
    pending: `${SELLERS_LISTING_PATH}?f[status.slug][]=pending`,
    inactive: `${SELLERS_LISTING_PATH}?f[status.slug][]=inactive`,
    rejected: `${SELLERS_LISTING_PATH}?f[status.slug][]=rejected`,
    'On Vacation': `${SELLERS_LISTING_PATH}?f[on_vacation]=true`,
    'No Products': `${SELLERS_LISTING_PATH}?f[number_of_products][lte]=0`,
  },
};

export const PLATFORMS = [
  { id: 'Web', name: 'Web', value: 'Web' },
  { id: 'Android', name: 'Android', value: 'Android' },
  { id: 'iOS', name: 'iOS', value: 'iOS' },
];

export const PLATFORM_ICONS = {
  Android: <GrAndroid size={14} color={'var(--gray-300)'} />,
  iOS: <SiApple size={14} color={'var(--gray-300)'} />,
  Web: <HiOutlineGlobeAlt size={16} color={'var(--gray-300)'} />,
};

export const DELIVERY_WEIGHT_RANGES = [
  { min: 0, max: 3, key: 'price_0_3kg', title: '0-3 KG' },
  { min: 3, max: 6, key: 'price_3_6kg', title: '3-6 KG' },
  { min: 6, max: null, key: 'price_above_6kg', title: '> 6 KG' },
];

export const FIELD_TYPES = {
  INPUT: 'input',
  SELECT: 'select',
  INFINITE_SELECT: 'infinite-select',
  IMAGE: 'image',
  PIN_LOCATION: 'pin-location',
  TIME_PICKER: 'time-picker',
  PHONE_NUMBER: 'phone-number',
  TAGS: 'tags',
  SEARCH_JARVIS_CLIENT: 'search-jarvis-client',
};

export const getExpectedDeliveryDays = (maxDeliveryDays = 0) => {
  const options = [{ name: 'Same Day', id: 1 }];
  for (let i = 2; i <= Number(maxDeliveryDays ?? 0); i++) {
    options.push({ name: i, id: i });
  }
  return options;
};

export const SELLER_BULK_ACTION_TYPES = {
  LINE_ITEM_IDS: 'line_item_ids',
  CONSIGNMENT_IDS: 'consignment_ids',
};

export const RESPONSE_TYPES = {
  blob: 'blob',
  json: 'json',
};

export const SELLER_STATUS = {
  PENDING: 'pending',
};

export const MODAL_TYPES = {
    RECORDINGS: 'RECORDINGS',
    REASON: 'REASON',
    LINE_ITEMS: 'LINE_ITEMS',
    CONFIRMATION: 'CONFIRMATION',
    UPDATE_ADDRESS: 'UPDATE_ADDRESS',
    EDIT_PRODUCTS: 'EDIT_PRODUCTS',
    ADVANCE_PAYMENT: 'ADVANCE_PAYMENT',
    EXPORT_CONFIRMATION: 'EXPORT_CONFIRMATION',
    ADD_FOLLOW_UP: 'ADD_FOLLOW_UP',
    VIEW_FOLLOW_UP: 'VIEW_FOLLOW_UP',
    REFUND_PAYMENT: 'REFUND_PAYMENT',
  };
export const CALL_TYPE = {
  IN: 'in',
  OUT: 'out',
}

export const CANCELATION_SLUGS = {
 CANCELLED_BY_SELLER : 'cancelled-by-seller',
 CANCELLED_BY_BUYER : 'cancelled-by-buyer',
}